import React from 'react';
import { T } from '../../lib/tokens';

interface VendorTileProps {
  vendor: string;
  size?: number;
  style?: React.CSSProperties;
}

interface VendorEntry {
  initials: string;
  bg: string;
  fg: string;
}

const knownVendors: Record<string, VendorEntry> = {
  uber:       { initials: 'UB', bg: '#000000', fg: '#FFFFFF' },
  xero:       { initials: 'XO', bg: '#13B5EA', fg: '#FFFFFF' },
  aws:        { initials: 'AW', bg: '#FF9900', fg: '#232F3E' },
  bunnings:   { initials: 'BN', bg: '#0D5257', fg: '#FFFFFF' },
  stripe:     { initials: 'ST', bg: '#635BFF', fg: '#FFFFFF' },
  officeworks:{ initials: 'OW', bg: '#D4111E', fg: '#FFFFFF' },
  bp:         { initials: 'BP', bg: '#009900', fg: '#FFFF00' },
  doordash:   { initials: 'DD', bg: '#FF3008', fg: '#FFFFFF' },
  coles:      { initials: 'CO', bg: '#E01A22', fg: '#FFFFFF' },
  zeller:     { initials: 'ZL', bg: '#6C47FF', fg: '#FFFFFF' },
  anthropic:  { initials: 'AN', bg: '#D4A27F', fg: '#1A1A2E' },
  vistaprint: { initials: 'VP', bg: '#00304E', fg: '#FF6600' },
  namecheap:  { initials: 'NC', bg: '#FF5100', fg: '#FFFFFF' },
  opensummit: { initials: 'OS', bg: '#1A1A2E', fg: '#A8C79E' },
};

function getInitials(name: string): string {
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

function getVendorEntry(vendor: string): VendorEntry {
  const key = vendor.toLowerCase().replace(/[^a-z]/g, '');
  if (knownVendors[key]) return knownVendors[key];

  // Check if key starts with a known vendor name
  for (const [k, v] of Object.entries(knownVendors)) {
    if (key.startsWith(k) || k.startsWith(key)) return v;
  }

  return {
    initials: vendor.trim() ? getInitials(vendor) : '?',
    bg: T.paper2,
    fg: T.graphite,
  };
}

export const VendorTile: React.FC<VendorTileProps> = ({ vendor, size = 30, style }) => {
  const entry = getVendorEntry(vendor);
  const fontSize = Math.round(size * 0.38);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: entry.bg,
        color: entry.fg,
        fontSize,
        fontFamily: "'Geist', sans-serif",
        fontWeight: 600,
        letterSpacing: '0.02em',
        flexShrink: 0,
        ...style,
      }}
      title={vendor}
    >
      {entry.initials}
    </div>
  );
};
